import React from 'react'
import { useStore } from '../../store'
import { getCdnAssetUrl } from '../../helpers/assets'

function PropertyLogo({className = ''}) {
  const { data } = useStore()

  return (
    data?.property && (
      <img alt={data.property.property_name} src={getCdnAssetUrl(data.property.real_estate_company.company_logo)} className={`h-[28px] ${className}`} />
    )
  )
}

export default PropertyLogo
